import type { IFilterableListItem, IMultiSelectProps, IOmit } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, MultiSelect, Skeleton } from '@sixui/ui';

import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useUserBadgesQuery } from '~/lib/api/modules/UserBadges/hooks/useUserBadgesQuery';

export type IUserBadgesSelectorProps = IOmit<IMultiSelectProps, 'items'> & {
  appId: string;
};

export const UserBadgesSelector = forwardRef<
  HTMLInputElement,
  IUserBadgesSelectorProps
>(function UserBadgesSelector(props, forwardedRef) {
  const { appId, ...other } = props;
  const userBadgesQuery = useUserBadgesQuery({ appId });
  const items: Array<IFilterableListItem> =
    userBadgesQuery.data?.userBadges.map(({ _id, name }) => ({
      value: _id,
      label: name,
    })) ?? [];

  return userBadgesQuery.isError ? (
    <ErrorMessage error={userBadgesQuery.error} />
  ) : !!userBadgesQuery.data || !userBadgesQuery.isLoading ? (
    <MultiSelect
      {...other}
      items={items}
      ref={forwardedRef}
      disabled={userBadgesQuery.isLoading}
    />
  ) : (
    <Skeleton>
      <Field />
    </Skeleton>
  );
});
